var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Production-Plan-Item"},[_c('PageTitle',{attrs:{"imagem":"bottles.png","main":"Cadastro de Insumos","sub":""}}),_c('RegisterInputsEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }